import { useTranslation } from 'react-i18next';

import { formatDashDate, formatDate } from '@/utils';
import { formatPrice } from '@/utils/money';

import PaymentStatusChip from './PaymentStatusChip';
import { ButtonsCell } from './components';
import { useGetPaymentReference } from './hooks';

export function MobileCell({ row }) {
	const { t } = useTranslation();

	const getPaymentReference = useGetPaymentReference();

	return (
		<div className="flex w-full flex-col gap-3">
			<div className="flex w-full flex-col gap-1">
				<div className="flex items-start justify-between gap-2">
					<div className="flex w-full flex-col gap-1">
						<span className="text-xs font-semibold leading-5 text-grey-500">
							{getPaymentReference(row.original)}
						</span>

						<span className="text-xs leading-5 text-grey-500">
							{row.original.createdAt
								? formatDate(row.original.createdAt)
								: '-'}
						</span>

						<span className="mb-1 text-xs leading-5 text-grey-500">
							{row.original.periodFrom && row.original.periodTo
								? t(
										'billing.subscription.table.billingRange.description',
										{
											range1: formatDashDate(
												row.original.periodFrom
											),
											range2: formatDashDate(row.original.periodTo)
										}
									)
								: '-'}
						</span>
					</div>
				</div>

				<div className="flex items-center justify-between">
					<span className="text-xs font-semibold leading-5">
						{formatPrice({
							amount: row.original.amount,
							currency: row.original.currency
						})}
					</span>
					<PaymentStatusChip
						type={row.original.type}
						status={row.original.status}
					/>
				</div>
			</div>
			<ButtonsCell row={row} variant="outline" mobile />
		</div>
	);
}
